import apiHandler from "../core/apiHandler";

const cashMovementApi = apiHandler("cash/movements");

export default cashMovementApi;